import { all, put, takeLatest } from 'redux-saga/effects'
import * as CitaPreviaActions from '../actions/citaPreviaActions'
import { resetTallerAndService } from '../actions/citaPreviaActions'
import { resetCestaTaller } from '../actions/cestaActions'
import {
  CitaPreviaEnum,
  citaPreviaSteps,
} from '../../components/CitaPrevia/CitaPreviaSteps'
import { navigate } from 'gatsby'

function* serviceNotAvailable() {
  yield put(resetTallerAndService())
  yield put(resetCestaTaller())
  yield navigate(citaPreviaSteps[CitaPreviaEnum.SELECCION_TALLER].route)
}

function* sagas() {
  return all([
    yield takeLatest(
      CitaPreviaActions.SERVICE_NOT_AVAILABLE,
      serviceNotAvailable
    ),
  ])
}

export default sagas
